import script from "./TopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=965868da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965868da"]])

export default __exports__